module.exports = {"440604010":"石湾镇街道","440604011":"张槎街道","440604012":"祖庙街道","440604100":"南庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440604.json
// module id = 1985
// module chunks = 0